import type { Instructor } from "@/types/database/instructor";

export const getInitialValues = (instructor?: Instructor) => {
  const initialValues = {
    name: '',
    phone: '',
    title: '',
    expertise: '',
    introduction: '',
  };

  if (instructor) {
    initialValues.name = instructor.name;
    initialValues.phone = instructor.phone;
    initialValues.title = instructor.title;
    initialValues.expertise = instructor.expertise;
    initialValues.introduction = instructor.introduction;
  }

  return initialValues;
}